import * as Search from "./ClientSearch";

const ClientSearchComponent = Search.ClientSearch;

export default ClientSearchComponent;
